import { InstructionComponentProps } from "../InstructionComponent"
import ImageTextComponent from "../../ImageTextComponent"

const DataSyncInstructions: InstructionComponentProps = {
    name: "Meine gesammelten Ring-Daten sind nicht aktuell, was kann ich tun?",
    path: "/help/patient/data_sync",
    description:
        "Wenn Ihre gesammelten Daten in der DOOR Studie Connect App nicht aktuell erscheinen, können Sie folgende Schritte durchführen, um die Daten zu aktualisieren.",
    both: [
        <ImageTextComponent
            text={
                <>
                    <strong>Schritt 1:</strong> Öffnen Sie zuerst die Oura App auf Ihrem Smartphone. Warten Sie, bis die am oberen Bilschirmrand de 'Aktualisieren' Anzeige verschwindet.
                    Dies stellt sicher, dass alle Daten vom Oura-Ring übertragen wurden.
                </>
            }
            images={[]}
        />,
        <ImageTextComponent
            text={
                <>
                    <strong>Schritt 2:</strong> Schließen Sie die DOOR Studie Connect App vollständig. 
                    Auf iOS: Wischen Sie die App aus dem App-Switcher nach oben. 
                    Auf Android: Tippen Sie auf das "Letzte Apps"-Symbol und wischen Sie die App weg.
                </>
            }
            images={[]}
        />,
        <ImageTextComponent
            text={
                <>
                    <strong>Schritt 3:</strong> Öffnen Sie die DOOR Studie Connect App erneut. 
                    Die App wird beim Start automatisch versuchen, die neuesten Daten von Oura abzurufen. 
                    Nach einigen Sekunden sollten Sie Ihre aktuellen Daten sehen, die Sie durch den Ring gesammelt haben.
                </>
            }
            images={[]}
        />
    ]
}

export default DataSyncInstructions 